import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit {
    @Input() modalMessage: string;
    @Input() userTypeToBeDeleted: string;
    constructor(private ngbActiveModal: NgbActiveModal) {}

    ngOnInit(): void {}

    //modal click for Delete UserType
    modalOkClick() {
        this.ngbActiveModal.close(true);
    }
    //modal click for Delete UserType
    modalCancelClick() {
        this.ngbActiveModal.close(false);
    }
}
